import { dataCrownSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCrownSolid = /*#__PURE__*/createIcon(dataCrownSolid)
export default IconCrownSolid
